import { render, staticRenderFns } from "./PointDetails.vue?vue&type=template&id=f9cf910a&scoped=true&"
import script from "./PointDetails.vue?vue&type=script&lang=js&"
export * from "./PointDetails.vue?vue&type=script&lang=js&"
import style0 from "./PointDetails.vue?vue&type=style&index=0&id=f9cf910a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cf910a",
  null
  
)

export default component.exports